(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ars-storefront-v2"] && !Shopify.designMode) return;
  try {
    function initArs(root){if(root.dataset.arsInitialized)return;root.dataset.arsInitialized='true';const buttons=root.querySelectorAll('[data-ars-filter]');const cards=root.querySelectorAll('[data-ars-category]');function filter(value){buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.arsFilter===value)));cards.forEach(card=>{card.hidden=value!=='all'&&card.dataset.arsCategory!==value;});}buttons.forEach(button=>button.addEventListener('click',()=>filter(button.dataset.arsFilter)));root.querySelectorAll('.ars-menu nav a').forEach(link=>link.addEventListener('click',()=>{const key=link.getAttribute('href');const target=root.querySelector(key);filter(target?.dataset.arsFilter||'all');root.querySelector('.ars-menu').open=false;}));}document.querySelectorAll('.ars-store').forEach(initArs);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ars-store').forEach(initArs));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ars-storefront"] && !Shopify.designMode) return;
  try {
    
  function initArs(root){
    if(root.dataset.arsInitialized)return;
    root.dataset.arsInitialized='true';
    const buttons=root.querySelectorAll('[data-ars-filter]');
    const cards=root.querySelectorAll('[data-ars-category]');
    function filter(value){buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.arsFilter===value)));cards.forEach(card=>{card.hidden=value!=='all'&&card.dataset.arsCategory!==value;});}
    buttons.forEach(button=>button.addEventListener('click',()=>filter(button.dataset.arsFilter)));
    root.querySelectorAll('.ars-menu nav a').forEach(link=>link.addEventListener('click',()=>{const key=link.getAttribute('href');const target=root.querySelector(key);filter(target?.dataset.arsFilter||'all');root.querySelector('.ars-menu').open=false;}));
    root.querySelector('.ars-feature').addEventListener('click',()=>filter('all'));
    root.querySelector('.ars-button').addEventListener('click',()=>filter('all'));
  }
  document.querySelectorAll('.ars-store').forEach(initArs);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ars-store').forEach(initArs));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
